import { Component, OnInit } from '@angular/core';
import { moduloPromociones } from '../../diccionarios/PromocionesModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { PromocionesService } from '../../services/promociones.service';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { Promocion, SavePromocion } from '../../modelos/Promocion';
import { Router } from '@angular/router';
import { dateFormatter } from 'src/utils/gridValueGetters';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/model/interfaces/response';
import { downloadBase64File } from 'src/utils/utils';

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.css']
})
export class PromocionesComponent implements OnInit {
  public DAT_TITULOS: any = moduloPromociones.titulos.promociones;
  public DAT_BTNS: any = moduloPromociones.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloPromociones.button.buttonsCss;
  public DAT_AG_GRID: any = moduloPromociones.agGrid;
  public DAT_MSG: any = moduloPromociones.mensajes;

  public gridApi: GridApi;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public rowData: Promocion[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;

  public cmbTipoPromocion = [];
  public idPromo;
  public tipoPromo;

  public copyIdPromo?: string;
  public verFormulario = false;
  onlyActives = true;

  get promosId() {
    return this.rowData.map((item) => item.id_promo).sort()
  }

  get selectedPromos() {
    if (!this.gridApi) return [];
    const selected = this.gridApi.getSelectedRows();
    return selected.map((item) => item.id_promo).sort()
  }


  constructor(
    private router: Router,
    private readonly toastrService: ToastrService,
    private _util: UtilsService,
    private promocionesService: PromocionesService,
  ) {}


  setKeyEmptyDisabled(form, key, value = '') {
    // console.log("form, key", form, key)
    form.get(key).setValue(value);
    form.get(key).setValidators([]);
    form.get(key).updateValueAndValidity();
    form.get(key).disable();
  }

  ngOnInit() {
    this.girdComponent();
    this.tiposDePromociones();
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefs = [
      {
        headerName: 'Id promo',
        field: 'id_promo',
        minWidth: 130,
        sortable: true,
        filter: true,
        checkboxSelection: true
      },
      {
        headerName: 'Descripción',
        field: 'descripcion_corta',
        minWidth: 300,
        sortable: true,
        filter: true,
        tooltipField: 'descripcion_corta',
      },
      {
        headerName: 'Tipo Promoción',
        field: 'tipo_promo',
        valueGetter: (params) => {
          const tipo = params.data.tipo_promo;
          return tipo > 0 ? this.cmbTipoPromocion.find(element => element.id == tipo ? element.descripcion : '').descripcion : '';
        },
        minWidth: 300,
        sortable: true,
        filter: true,
        tooltipValueGetter: (params) => {
          const tipo = params.data.tipo_promo;
          return tipo > 0 ? this.cmbTipoPromocion.find(element => element.id == tipo ? element.descripcion : '').descripcion : '';
        }
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fecha_inicio',
        minWidth: 130,
        sortable: true,
        filter: true,
        valueFormatter: dateFormatter
      },
      {
        headerName: 'Fecha Fin',
        field: 'fecha_fin',
        minWidth: 130,
        sortable: true,
        filter: true,
        valueFormatter: dateFormatter
      },
      {
        headerName: 'Envío a SAP',
        field: 'send_sap',
        minWidth: 130,
        sortable: true,
        filter: true,
        valueGetter: (params) => params.data.send_sap == 1 ? 'Si' : 'No'
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        pinned: 'right',
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        pinned: 'right',
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      },
      {
        headerName: '',
        cellRenderer: 'iconButtonRenderer',
        width: 60,
        pinned: 'right',
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.sendToVdi.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
          iconBtn: 'fas fa-paper-plane',
          tooltipMensaje: 'Enviar a SAP'
        },
      },
      {
        headerName: '',
        cellRenderer: 'iconButtonRenderer',
        width: 60,
        pinned: 'right',
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.openDuplicarModal.bind(this),
          label: '',
          classBtn: 'btn btn-success btn-block',
          iconBtn: 'far fa-copy',
          tooltipMensaje: 'Duplicar promoción'
        },
      }
    ];
  }

  eliminar({ rowData }) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `ID PROMO: ${rowData.id_promo}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.promocionesService.borrar(rowData.id_promo),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  sendToVdi({ rowData }) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de enviar el siguiente registro?',
        text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Enviar a saap',
        funcion: this.promocionesService.sendVdi(rowData.id_promo),
      })
      .finally(() => this.loading = false);
  }

  obtenerTodo() {
    this.loading = true;
    this.promocionesService.getAll(this.onlyActives).subscribe(
      (resp) => {
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    )
  }

  tiposDePromociones() {
    this.loading = true;
    this.promocionesService.tiposDePromociones().subscribe(
      (resp) => {
        this.cmbTipoPromocion = Object.entries(resp).map(( [k, v] ) => ({
          id: v as number,
          descripcion: k
       }));
       this.cmbTipoPromocion = this.cmbTipoPromocion.filter((item) => item.id > 0);
        this.loading = false;
        this.obtenerTodo();
      },
      (error) => {
        // this.cmbTipoPromocion = [];
        this.loading = false;
      }
    )
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  opacityModalOpcionesDeAgregados() {
    document.getElementById('verOpcionesDeAgregados').style.zIndex = '1050';
  }

  closeModal() {
    this.promoExist = false;
    document.getElementById('cerrarModal').click();
  }

  closeDuplicarModal() {
    this.copyIdPromo = undefined;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.verFormulario = true
    this.openModal();
  }

  guardar(payload: SavePromocion) {
    payload.promo.fecha_fin = payload.promo.fecha_fin ? payload.promo.fecha_fin + "T23:59:59.873Z" : null;
    payload.promo.fecha_inicio = payload.promo.fecha_inicio ? payload.promo.fecha_inicio + "T00:00:00.873Z" : null;

    console.log("payload", payload);

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `ID PROMO: ${payload.promo.id_promo}`,
        action: this.isCreate ? this.DAT_BTNS.nuevo : this.DAT_BTNS.editar,
        funcion: this.promocionesService.crearPromo(payload.promo),
      })
      .then((res: any) => {
        //this.obtenerTodo();
        this.closeModal();
        this.loading = false;
        this.isCreate = false;
        this.promoExist = true;
        this.router.navigate(['/promociones', payload.promo.id_promo]);
      })
      .catch((error) => {

        this.loading = false;

      })
      .finally(() => {
        this.loading = false;

      });
  }

  promoExist = false;
  editar({ rowData }) {
    this.router.navigate(['/promociones', rowData.id_promo]);
  }

  openDuplicarModal({ rowData }) {
    this.copyIdPromo = rowData.id_promo;
    document.getElementById('duplicarModal').click();
  }

  sendAll() {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de realizar esta acción?',
        action: 'Enviar a saap',
        funcion: this.promocionesService.sendAll(),
      })
      .then((res: ApiResponse<void>) => this.toastrService.success(res.mensaje, `${res.key}`))
      .finally(() => this.loading = false);
  }

  onPageSizeChanged(event: number) {
    this.gridApi.paginationSetPageSize(event);
  }

}
